export enum DocumentManagerColumKeys {
  DOCUMENT_NAME = "documentName",
  ASSIGNED_TO = "assignTo",
  MAPPED_BY = "mappedBy",
  DATE = "mappedDate",
  CATEGORY = "category",
  TYPE = "entityType",
  ACTIONS = "actions",
  DEBTOR_NAME = "debtorName",
  CREDITOR_NAME = "creditorName",
}